/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { SvgTypeControllerService } from './services/svg-type-controller.service';
import { DownloadControllerService } from './services/download-controller.service';
import { ReportControllerService } from './services/report-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    SvgTypeControllerService,
    DownloadControllerService,
    ReportControllerService,
    ApiConfiguration
  ],
})
export class ExcelModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ExcelModule> {
    return {
      ngModule: ExcelModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ExcelModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ExcelModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
